import { infotechInstance } from '@/api/index';

function checkInstalled() {
    return infotechInstance.post("/?op=setup");
}

function openCertList(params) {
    return infotechInstance.post("/?op=certSelect", params);
}

function doScrap(params) {
    return infotechInstance.post("/?op=execute", params);
}


export { checkInstalled, openCertList, doScrap };